import { Config } from '~domain/entities/Config';
import { StoreDetailsRepository } from '~repositories/StoreDetailsRepository';
import { diContainer } from '~setup/diContainer';
import serviceNames from '../../service-setup/StoresService';

export class LoadInStorePickupBannerUseCase {
    private storeDetailsRepository: StoreDetailsRepository;
    private configService: Config;

    constructor(
        storeDetailsRepository = diContainer.get(serviceNames.storeDetailsRepository),
        configService = diContainer.get(serviceNames.config)
    ) {
        this.storeDetailsRepository = storeDetailsRepository;
        this.configService = configService;
    }

    public async execute() {
        const { inStorePickupBannerNodeId } = this.configService;

        if (inStorePickupBannerNodeId) {
            await this.storeDetailsRepository.loadInStorePickupBannerTemplate(
                inStorePickupBannerNodeId
            );
        }
    }
}
